<template>
  <div
    class="searchPage"
    :style="{ backgroundImage: 'url(' + imagePath.myBGI + ')' }"
  >
    <common-header></common-header>
    <div class="searchContainer">
      <div class="title">
        “<span>{{ $route.query.searchText }}</span
      >”相关结果,共找到<span>{{ queryParams.total }}</span
      >个
      </div>
      <div class="content" v-for="item in searchList7" :key="item.catId">
        <!-- 课程 -->
        <div class="course" v-if="item.catLevel === 1 || item.catLevel === 2">
          <img
            class="imgUrl cp"
            :src="item.imgUrl"
            @click="queryOneCategory(item.catId)"
          />
          <div class="courseContent">
            <div class="contentTitle" v-html="item.catNameHighlights">
              <!-- {{ item.catName }} -->
            </div>
            <div class="description">
              <span>课程简介：</span>{{ item.description || "无" }}
            </div>
            <div class="courseList" v-if="item.categoryTreeDTO">
              <div
                class="courseItem cp"
                v-for="i in item.expandAllList"
                :key="i.catId"
                v-html="i.catNameHighlights"
                @click.stop="goCourseDetails(i)"
              ></div>
              <div
                class="courseItem cp"
                v-if="item.categoryTreeDTO.length > 8 && !item.isOpen"
                @click="expandAll(item)"
              >
                展开全部
              </div>
              <div
                class="courseItem cp"
                v-if="item.isOpen"
                @click="collapseAll(item)"
              >
                收起全部
              </div>
            </div>
          </div>
        </div>
        <!-- 课件 -->
        <div
          class="courseWare cp"
          v-if="item.catLevel === null"
          @click="goCourseWare(item.catId)"
        >
          <div class="cwHeader">
            <div class="cwLogo">PPT</div>
            <div class="cwTitle" v-html="item.catNameHighlights"></div>
          </div>
          <img class="cwNext" :src="imagePath.PPTNext" />
          <img class="cwNexted" :src="imagePath.PPTNexted" />
        </div>
        <!-- 学科 -->
        <div class="subject" v-if="item.catLevel === 0">
          <img :src="item.imgUrl" alt="" class="imgUrl cp" @click="goHome" />
          <div class="subjectContent">
            <div class="subjectTitle" v-html="item.catNameHighlights"></div>
            <div class="subjectDescription">
              <span>课程简介：</span>{{ item.description || "无" }}
            </div>
          </div>
        </div>
      </div>
      <div class="noData" v-if="searchList7.length === 0">
        <img :src="imagePath.noData" alt="" />
        <div class="noDataTitle">暂无内容</div>
        <div class="returnPrevious" @click="$router.go(-1)">返回</div>
      </div>
      <a-pagination
        class="pagination"
        :current="queryParams.page"
        align="right"
        :total="queryParams.total"
        :page-size="queryParams.pageSize"
        :show-total="(total) => `共${total}个`"
        :default-current="1"
        show-size-changer
        :page-size-options="pageSizeOptions"
        @change="onChange"
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";
import { search, queryOneCategory } from "@/api/home";
import CommonHeader from "@/components/header/index";
import { getClassNumByClassLevelId } from "@/utils/getColor.js";

export default {
  name: "Search",
  components: {
    CommonHeader
  },
  data() {
    return {
      imagePath,
      searchList: [], // 搜索列表
      pageSizeOptions: ["3", "6", "9", "12", "15"],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 3
      },
      courseDetails: {} // 课程详情
    };
  },
  computed: {
    // 如果搜索二级学科的课程列表长度大于8了，那么就应该显示展示全部按钮，默认收起的状态只展示7个搜索
    searchList7() {
      const list = JSON.parse(JSON.stringify(this.searchList));
      return list.map((item) => {
        if (item.categoryTreeDTO && item.categoryTreeDTO.length > 8) {
          item.categoryTreeDTO7 = JSON.parse(
            JSON.stringify(item.categoryTreeDTO)
          );
          item.categoryTreeDTO7.splice(7);
          item.isOpen = false;
        } else {
          item.categoryTreeDTO7 = item.categoryTreeDTO;
        }
        item.expandAllList = item.categoryTreeDTO7;
        return item;
      });
    }
  },
  created() {
    this.search(this.$route.query.searchText);
  },
  updated() {
    // 改变分页样式 根据classNum存的数据而变化
    const color = "#66A8F5";
    // 页数序列
    const pagination = document.getElementsByClassName("ant-pagination-item");
    if (pagination.length > 0) {
      for (let i = 0; i < pagination.length; i++) {
        pagination[i].style.borderColor = color;
        pagination[i].style.backgroundColor = "#fff";
        pagination[i].getElementsByTagName("a")[0].style.color = color;
      }
    }
    // 被选中的页数序列
    const paginationActive = document.getElementsByClassName(
      "ant-pagination-item-active"
    );
    if (paginationActive.length > 0) {
      for (let i = 0; i < paginationActive.length; i++) {
        paginationActive[i].style.borderColor = color;
        paginationActive[i].style.backgroundColor = color;
        paginationActive[i].getElementsByTagName("a")[0].style.color = "#fff";
      }
    }
    // 左滑
    const paginationPrev = document
      .getElementsByClassName("ant-pagination-prev")[0]
      .getElementsByTagName("a")[0];
    paginationPrev.style.borderColor = color;
    paginationPrev.style.color = color;
    // 右滑
    const paginationNext = document
      .getElementsByClassName("ant-pagination-next")[0]
      .getElementsByTagName("a")[0];
    paginationNext.style.borderColor = color;
    paginationNext.style.color = color;
    // 被禁用的左右滑
    const paginationDisabled = document
      .getElementsByClassName("ant-pagination-disabled")[0]
      .getElementsByTagName("a")[0];
    paginationDisabled.style.borderColor = "#d9d9d9";
    paginationDisabled.style.color = "rgba(0, 0, 0, 0.25)";
    const paginationSelection = document.getElementsByClassName(
      "ant-select-selection"
    )[0];
    paginationSelection.style.borderColor = color;
    paginationSelection.style.color = color;
    // console.log(pagination, "paginationPrev");
  },
  watch: {
    "$route.query.searchText"(val) {
      this.search(val);
    }
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    },
    // 收起
    collapseAll(val) {
      val.expandAllList = val.categoryTreeDTO7;
      val.isOpen = false;
      this.$forceUpdate();
      // console.log(val, "expandAll");
    },
    // 展开
    expandAll(val) {
      val.expandAllList = val.categoryTreeDTO;
      val.isOpen = true;
      this.$forceUpdate();
      // console.log(val, "expandAll");
    },
    // 跳转到课程详情页面
    goCourseDetails(val) {
      this.$router.push({
        path: "/courseDetails",
        query: {
          id: val.catId,
          classNum: getClassNumByClassLevelId(val.classLevelId)
        }
      });
    },
    // 跳转到查看课件页面
    goCourseWare(id) {
      // console.log(id, "goCourseWare");
      this.$router.push({ path: "/lookPPT", query: { id: id }});
    },
    // 跳转到二级课程页面
    goHomeDetails() {
      this.$router.push({
        path: "/homeDetails",
        query: {
          id: this.courseDetails.parentId
        }
      });
    },
    // 获取课程信息
    async queryOneCategory(id) {
      const { data, status, msg } = await queryOneCategory(id);
      if (status === 200) {
        this.courseDetails = data;
        sessionStorage.setItem(
          "classNum",
          getClassNumByClassLevelId(data.classLevelId)
        );
        // console.log(data, "courseDetails");
        this.goHomeDetails();
      } else {
        this.$message.error(msg);
      }
    },
    // 页数改变
    onChange(page) {
      this.queryParams.page = page;
      this.search(this.$route.query.searchText);
    },
    // 每页条数改变
    onShowSizeChange(page, pageSize) {
      this.queryParams.page = page;
      this.queryParams.pageSize = pageSize;
      this.search(this.$route.query.searchText);
    },
    // 替换搜索文字
    searchText() {
      this.searchList = this.changeText(this.searchList);
      this.searchList.forEach((i) => {
        if (i.categoryTreeDTO !== null) {
          i.categoryTreeDTO = this.changeText(i.categoryTreeDTO);
        }
      });
      // console.log(this.searchList, "this.searchList");
    },
    // 替换高亮方法
    changeText(list) {
      const search = this.$route.query.searchText;
      return list.map((item) => {
        for (const key in item) {
          if (key === "catName") {
            const replaceReg = new RegExp(search, "g"); // 匹配关键字正则
            const replaceString = `<span class="highlights">${this.$route.query.searchText}</span>`; // 高亮替换v-html值
            item[key + "Highlights"] = item[key].replace(
              replaceReg,
              replaceString
            ); // 开始替换
          }
        }
        return item;
      });
    },
    // 搜索
    async search(val) {
      const { data, status, msg } = await search(
        this.queryParams.page,
        this.queryParams.pageSize,
        val
      );
      if (status === 200) {
        this.searchList = data.entityList;
        this.queryParams.total = data.total;
        // console.log(this.searchList, "searchList");
        this.searchText();
      } else {
        console.log(data, "search err");
        this.$message.error(msg)
      }
    }
  }
};
</script>

<style lang="less" scpoed>
.searchPage {
  width: 100%;
  // height: 100%;
  background-color: #ddf4ff;
  background-size: cover;
  background-repeat: no-repeat;

  .searchContainer {
    position: relative;
    margin: 0 auto;
    width: 1200px;
    height: 971px;
    overflow: hidden;

    .title {
      margin-top: 64px;
      margin-bottom: 30px;
      font-size: 24px;
      color: #333333;

      span {
        font-weight: 600;
      }
    }

    .content {
      > div {
        margin-bottom: 40px;
      }

      .course {
        display: flex;

        .imgUrl {
          margin-right: 20px;
          width: 350px;
          height: 196px;
          object-fit: cover;
          border-radius: 10px;
        }

        .courseContent {
          width: 792px;

          .contentTitle {
            margin-bottom: 20px;
            height: 20px;
            line-height: 20px;
            font-weight: 600;
            font-size: 20px;
            color: #333333;
          }

          .description {
            width: 792px;
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            span {
              font-weight: 550;
            }
          }

          .courseList {
            display: flex;
            flex-wrap: wrap;
            position: relative;
            width: 790px;
            min-height: 120px;

            .courseItem {
              margin-right: 34px;
              margin-top: 20px;
              width: 172px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              background: #f3f3f3;
              border-radius: 6px;
              font-size: 16px;
              color: #666666;
            }

            .courseItem:nth-child(4n) {
              margin-right: 0;
            }

            .expandAll {
              width: 172px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              background: #f3f3f3;
              border-radius: 6px;
              font-size: 16px;
              color: #666666;
            }

            .courseItem:hover {
              background: #ddf4ff;
            }
          }
        }
      }

      .courseWare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 50px 0 11px;
        width: 1160px;
        height: 72px;
        background: #f3f3f3;
        border-radius: 10px;
        box-sizing: border-box;

        .cwHeader {
          display: flex;
          align-items: center;

          .cwLogo {
            margin-right: 15px;
            width: 80px;
            height: 50px;
            line-height: 50px;
            background: #5ab0f0;
            border-radius: 6px;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
          }

          .cwTitle {
            font-size: 18px;
            color: #333333;
          }
        }

        .cwNext,
        .cwNexted {
          width: 32px;
          height: 32px;
          object-fit: cover;
        }

        .cwNexted {
          display: none;
        }
      }

      .courseWare:hover {
        background: #ddf4ff;

        .cwNexted {
          display: block;
        }

        .cwNext {
          display: none;
        }
      }

      .subject {
        display: flex;

        .imgUrl {
          margin-right: 20px;
          width: 190px;
          height: 106px;
          border-radius: 8px;
          object-fit: cover;
        }

        .subjectContent {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 10px 0;
          box-sizing: border-box;

          .subjectTitle {
            height: 20px;
            line-height: 20px;
            font-size: 20px;
            font-weight: 600;
            color: #333;
          }

          .subjectDescription {
            width: 792px;
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            span {
              font-weight: 550;
            }
          }
        }
      }

      .courseWare + .courseWare {
        margin-top: 20px;
      }

      .subject + .subject {
        margin-top: 21px;
      }
    }

    .noData {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 150px;

      img {
        margin-bottom: 35px;
        width: 313px;
        height: 300px;
        object-fit: cover;
      }

      .noDataTitle {
        margin-bottom: 50px;
        font-size: 20px;
        color: #333333;
      }

      .returnPrevious {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #2abded;
        font-size: 16px;
        color: #ffffff;
        border-radius: 20px;
      }
    }

    .pagination {
      position: absolute;
      bottom: 127px;
      right: 0;
    }
  }
}
</style>
